module.exports = __webpack_public_path__ + "static/media/IMG_1508.e922931c.jpg";